import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { useLocation, useNavigate } from "react-router-dom";
import {
    ActionsLayout,
    Window,
    WindowActionsBar,
} from "@progress/kendo-react-dialogs";
import { getParamsSelector } from "../Slices/ParamSlice";

interface IFilters {
    widgets: any;
    sidebarItems: any;
    positionData: any;
    closeWindow: any;
    currentDashboard?: string;
    staticContent: any;
    customSize: any;
}

const ShareDashboard = (props: IFilters) => {
    const [success, updateSuccess] = useState(false);
    const location = useLocation();
    useEffect(() => {
        confirmSave();
    }, []);

    const params = useSelector(getParamsSelector);

    const checkInUse = (name: string) => {
        return false;
    };

    const confirmSave = () => {

        // Create a temporary textarea element to hold the token
        const textarea = document.createElement("textarea");

        let url: string = "https://localhost:5001";
        url = "https://serviceview.powerplatform.net";
        if (location.pathname == "/customers") {
            let newDashboardSet: any = [];
            newDashboardSet.push({
                widgets: createWidgetList(props.widgets),
                positionData: props.positionData,
                dbName: "Shared dashboard"
            });
            // Stringify the dashboard set
            const dashboardSetString: any = JSON.stringify(newDashboardSet);
            //console.log(params)
            // Encode to base64 (token-like format)
            const token: any = encodeURIComponent(btoa(dashboardSetString));
            let urlParams: any = "customerId=" + params.customerID;
            if (params.mainMachineSerialNo != null) {
                urlParams = urlParams + "&machine=" + encodeURIComponent(params.mainMachineSerialNo);
            }
            urlParams = urlParams + "&token=" + token;
            let dashboardName: string = "/customers";
            textarea.value = url + dashboardName + "?" + urlParams;
        }
        else {
            textarea.value = url + location.pathname;
        }
        // textarea.value = "https://serviceview.powerplatform.net/customers";
        document.body.appendChild(textarea);

        // Select the text and copy it to the clipboard
        textarea.select();
        textarea.setSelectionRange(0, 99999); // For mobile devices
        document.execCommand("copy");

        // Remove the textarea element
        document.body.removeChild(textarea);

        // Log success and update UI state
        console.log("Dashboard set copied to clipboard as token!");
        updateSuccess(true);
    };

    const createWidgetList = (w) => {
        const ids = [];
        for (var i = 0; i < w.length; i++) {
            ids.push(w[i].props.id);
        }
        return ids;
    };


    function renderContent() {
        return (
            <Fragment>
                {success && (
                    <Fragment>
                        <div style={{ height: "200px" }}>Url copied to pasteboard.</div>

                        <WindowActionsBar layout={"stretched"}>
                            <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                onClick={() => props.closeWindow()}
                                style={{ width: "150px" }}
                            >
                                Close
                            </button>
                        </WindowActionsBar>
                    </Fragment>
                )}
            </Fragment>
        );
    }
    return <Fragment>{renderContent()}</Fragment>;
};

export default ShareDashboard;
